import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutRoutingGuideProfileLookup extends Layout {
    sourceRoutingGuideProfile: DataSource;
    table1: Table;
}
